import React from 'react'
import clsx from 'clsx'

import useStyles from './styles'

export type BodyWidgetProps = {
  title: string
  infoComponent?: React.ReactNode
  className?: string
  children: React.ReactNode
}

const BodyWidget: React.ForwardRefRenderFunction<
  HTMLDivElement,
  BodyWidgetProps
> = ({ title, infoComponent, className, children }, ref) => {
  const classes = useStyles()

  return (
    <div ref={ref} className={clsx(classes.root, className)}>
      <div className={classes.header}>
        <div className={classes.title}>{title}</div>

        {infoComponent}
      </div>

      {children}
    </div>
  )
}

export default React.forwardRef(BodyWidget)
